// https://github.com/tldraw/tldraw/blob/c1b84bf2468caeb0c6e502f621b19dffe3aa8aba/packages/store/src/lib/Cache.ts#L0-L1
/** A micro cache used when storing records in memory (using a WeakMap). */ export class Cache {
    /** The map of items to their cached values. */ items = new WeakMap();
    /**
   * Get the cached value for a given record. If the record is not present in the map, the callback
   * will be used to create the value (with the result being stored in the cache for next time).
   *
   * @param item - The item to get.
   * @param cb - The callback to use to create the value when a cached value is not found.
   */ get(item, cb) {
        if (!this.items.has(item)) {
            this.items.set(item, cb(item));
        }
        return this.items.get(item);
    }
}
